import { render, staticRenderFns } from "./invoice-base.vue?vue&type=template&id=87e5aabe&"
import script from "./invoice-base.vue?vue&type=script&lang=ts&"
export * from "./invoice-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports